<template>
    <div class="registration-form-container">
        <div id="preloader" v-if="load" class="preloader"></div>
        <div class="titles">
            <p v-if="mode === 'profileCreation'" class="title">
                LET'S GET YOUR PROFILE SET UP
            </p>
            <p v-if="mode === 'events'" class="title">
                CREATE ACCOUNT TO SAVE AND MANAGE YOUR EVENTS
            </p>
            <p class="subtitle">REGISTER WITH</p>
        </div>
        <div class="social-icons">
            <div class="facebook">
                <a class="nostyle" href="/login/facebook?mode=venue-profile-register"
                    ><img src="/images/icons/social/facebook-light.png" alt="facebook-icon"
                /></a>
                <p>Facebook</p>
            </div>
            <div class="google">
                <a class="nostyle" href="/login/google?mode=venue-profile-register"
                    ><img src="/images/icons/social/google.png" alt="google-icon"
                /></a>
                <p>Google</p>
            </div>
            <div class="instagram">
                <a class="nostyle" href="/login/instagram?mode=venue-profile-register"
                    ><img src="/images/icons/social/instagram-light.png" alt="instagram-icon"
                /></a>
                <p>Instagram</p>
            </div>
        </div>
        <div class="divider">
            <div class="left-line"></div>
            <p>OR</p>
            <div class="right-line"></div>
        </div>
        <div class="registration-form">
            <form novalidate>
                <div class="email-input">
                    <input
                        v-model="formData.email"
                        class="form-control"
                        :class="formErrors.email ? 'is-invalid' : ''"
                        @input="validate('email')"
                        type="text"
                        name="email"
                        placeholder="Email *"
                    />
                    <div v-if="!emailTaken" class="invalid-feedback">
                        Your email is required.
                    </div>
                    <div v-show="emailTaken" class="user-taken-message">
                        This email has already been taken.
                    </div>
                </div>
                <div class="password-input">
                    <input
                        v-model="formData.password"
                        class="form-control"
                        :class="formErrors.password ? 'is-invalid' : ''"
                        @input="validate('password')"
                        type="password"
                        name="password"
                        placeholder="Password *"
                    />
                    <div class="invalid-feedback">
                        Your password must be at least 8 characters.
                    </div>
                </div>
                <div class="pw_confirm-input">
                    <input
                        :class="{
                            'form-control': true,
                            'is-invalid': formErrors.password_confirmation
                        }"
                        v-model="formData.password_confirmation"
                        @input="validate('password_confirmation')"
                        type="password"
                        name="password_confirmation"
                        placeholder="Confirm password *"
                    />
                    <div class="invalid-feedback">Your passwords must match.</div>
                </div>
                <div class="attestation-confirm">
                    <label class="checkbox-input">
                        <input
                            v-model="formData.attest_confirm"
                            @change="validate('attest_confirm')"
                            type="checkbox"
                            name="attest_confirm"
                        />
                        <span class="checkmark"></span>
                    </label>
                </div>
            </form>
        </div>
        <div class="attestation">
            <div class="text">
                <p>
                    By selecting the button below, I agree to Hedlyners
                    <a style="color: inherit" href="/terms-of-service">Terms of Service</a>,
                </p>
                <p>
                    <a style="color: inherit" href="/payment-terms">Payment Terms</a>,
                    <a style="color: inherit" href="/refunds-and-cancellation-policy"
                        >Refunds &amp; Cancellation Policy</a
                    >,
                    <a style="color: inherit" href="/dispute-resolution-policy"
                        >Dispute Resolution</a
                    >
                </p>
                <p style="text-decoration: underline">
                    Policy and
                    <a style="color: inherit" href="/off-platform-policy"
                        >Off-Platform Policy</a
                    >.
                </p>
                <div v-show="formErrors.attest_confirm" class="attest-confirm-error">
                    You must agree to the terms and policies.
                </div>
                <div
                    v-if="!formErrors.attest_confirm && serverErrMsg.length"
                    class="server-error"
                >
                    {{ serverErrMsg }}
                </div>
            </div>
        </div>
        <div class="step-action">
            <button v-if="mode === 'profileCreation'" @click="handleProfileCreationNextStep">
                CONTINUE
            </button>
            <button v-if="mode === 'events'" @click="venueEventsNextStep">CONTINUE</button>
            <button v-if="eventMode === 'eventCreation'" @click="eventCreationNextStep">
                CONTINUE
            </button>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'

    const inputValid = {
        email: (val) =>
            !!(
                val.length > 0 &&
                /^[a-zA-Z0-9.-_]+@[a-zA-Z-_]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/.test(val)
            ),
        password: (val) => !!(val.length >= 8 && val.length <= 255),
        password_confirmation: (pw, val) => !!(val && pw === val),
        attest_confirm: (val) => !!val
    }

    export default {
        name: 'RegistrationForm',

        props: {
            defaultVals: {
                type: Object,
                required: false,
                default: null
            },
            mode: {
                type: String
            }
        },

        data: () => ({
            formData: {
                email: '',
                password: '',
                password_confirmation: '',
                attest_confirm: false
            },

            formErrors: {
                email: false,
                password: false,
                password_confirmation: false,
                attest_confirm: false
            },

            load: false,
            emailTaken: false,
            serverErrMsg: '',
            eventMode: ''
        }),

        methods: {
            clearFormData() {
                for (const key of Object.keys(this.formData)) {
                    this.formData[key] = ''
                }
            },

            validate(name) {
                let keys = Object.keys(this.formErrors)

                if (name) {
                    if (name === 'password_confirmation') {
                        if (!inputValid[name](this.formData.password, this.formData[name])) {
                            this.formErrors[name] = true
                            return false
                        } else {
                            this.formErrors[name] = false

                            return true
                        }
                    } else {
                        if (!inputValid[name](this.formData[name])) {
                            this.formErrors[name] = true
                            return false
                        } else {
                            this.formErrors[name] = false
                            return true
                        }
                    }
                }

                let isInputValid = true

                for (let i = 0; i < keys.length; i++) {
                    if (keys[i] === 'password_confirmation') {
                        if (
                            !inputValid[keys[i]](
                                this.formData.password,
                                this.formData[keys[i]]
                            )
                        ) {
                            this.formErrors[keys[i]] = true
                            isInputValid = false
                        } else {
                            this.formErrors[keys[i]] = false
                        }
                    } else {
                        if (!inputValid[keys[i]](this.formData[keys[i]])) {
                            this.formErrors[keys[i]] = true
                            isInputValid = false
                        } else {
                            this.formErrors[keys[i]] = false
                        }
                    }
                }
                return isInputValid
            },

            async handleProfileCreationNextStep() {
                this.emailTaken = false
                if (this.validate()) {
                    this.load = true
                    try {
                        // eslint-disable-next-line
                        const response = await axios.post('/register/', {
                            email: this.formData.email,
                            password: this.formData.password,
                            password_confirmation: this.formData.password_confirmation
                        })
                        this.$emit('next', this.formData)
                    } catch (err) {
                        if (err.response?.data?.errors?.email.length) {
                            this.emailTaken = true
                        } else {
                            this.serverErrMsg = `[${err.response?.status}] : ${err.response?.data?.message}`
                        }
                        this.$emit('next', false)
                    } finally {
                        this.load = false
                    }
                }
            },
            venueEventsNextStep() {
                if (this.validate()) {
                    this.$emit('update:mode', 'paymentModal')
                }
            },
            eventCreationNextStep() {
                this.$emit('next', this.formData)
            }
        },
        mounted() {
            if (this.mode !== 'profileCreation') {
                this.eventMode = localStorage.getItem('mode')
            }
        }
    }
</script>
<style lang="scss" scoped>
    .registration-form-container {
        flex: 0 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 683px;

        justify-content: flex-start;

        .titles {
            order: 1;
            flex: 0 0 auto;

            .title {
                margin-top: 50px;
                font-family: 'Instrument Sans';
                font-style: normal;
                font-weight: 600;
                font-size: 21px;
                line-height: 24px;
                letter-spacing: 3px;
                text-transform: uppercase;
                color: white;
                text-align: center;
            }

            .subtitle {
                font-family: 'Instrument Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 22px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: white;
                text-align: center;
                margin-top: 20px;
            }
        }

        .social-icons {
            order: 2;
            flex: 0 0 auto;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 30px;
            margin-bottom: 0px;

            .facebook {
                order: 1;
                flex: 0 0 auto;
            }

            .google {
                order: 2;
                flex: 0 0 auto;
            }

            .instagram {
                order: 3;
                flex: 0 0 auto;
            }

            a.nostyle:link {
                text-decoration: inherit;
                color: inherit;
                cursor: pointer;
            }

            a.nostyle:visited {
                text-decoration: inherit;
                color: inherit;
                cursor: pointer;
            }
            img {
                width: 59px;
                height: 59px;
                background-color: black;
                padding: 13px;
                border: 1px solid white;
                border-radius: 50%;
            }

            p {
                font-family: Instrument Sans;
                font-style: normal;
                font-weight: 400;
                font-size: 15px;
                line-height: 150%;
                color: white;
                text-align: center;
            }
        }

        .divider {
            order: 3;
            flex: 0 0 auto;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 35px;
            margin-top: 31px;

            .left-line {
                order: 1;
                flex: 0 0 auto;
                width: 167.5px;
                height: 0px;
                background: white;
                border: 1px solid white;
            }

            p {
                order: 2;
                flex: 0 0 auto;
                font-family: 'Instrument Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 22px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: white;
                margin-top: auto;
                margin-bottom: auto;
            }

            .right-line {
                order: 3;
                flex: 0 0 auto;
                width: 167.5px;
                height: 0px;
                background: white;
                border: 1px solid white;
            }
        }

        .registration-form {
            order: 4;
            flex: 0 0 auto;
            margin-top: 31px;

            form {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 20px;

                input:not([type='checkbox']) {
                    width: 437px;
                    height: 40px;
                    border: 1px solid white;
                    border-radius: 50px;
                    background: transparent;
                    padding-left: 42.84px;
                    color: white;

                    input::placeholder {
                        color: white;
                    }
                }

                .pw_confirm-input {
                    margin-bottom: -35px;
                }

                .attestation-confirm {
                    position: relative;
                    top: 42px;
                    right: 294px;

                    .checkmark {
                        width: calc(100% - 6px);
                        height: calc(100% - 6px);
                        border-radius: 50%;
                        background-color: white;
                        display: none;
                    }

                    label {
                        width: 17px;
                        height: 17px;
                        border: 1px solid white;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        input {
                            position: absolute;
                            opacity: 0;
                        }

                        input:checked + .checkmark {
                            display: inline-block;
                        }
                    }
                }

                .invalid-feedback {
                    margin-left: 20px;
                }

                .user-taken-message {
                    color: #dc3545;
                    font-size: 0.875em;
                    margin-top: 0.25rem;
                }
            }
        }

        .attestation {
            order: 5;
            flex: 0 0 auto;
            margin-top: 20px;

            .text {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                p {
                    text-align: center;
                    font-family: Instrument Sans;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 150%;
                    color: #ffffff;
                    opacity: 0.6;
                    margin-bottom: 0px;
                }

                .attest-confirm-error,
                .server-error {
                    color: #dc3545;
                    font-size: 0.875em;
                    margin-top: 0.25rem;
                }
            }
        }

        .step-action {
            order: 6;
            flex: 0 0 auto;
            margin-top: 20px;
            margin-bottom: 50px;

            button {
                background-color: #e2ee79;
                border-radius: 50px;
                height: 62px;
                width: 467px;
                padding: 20px;
                display: flex;
                gap: 10px;
                align-items: center;
                justify-content: center;
                border: none;
                font-family: 'Instrument Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 22px;
                text-align: center;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: #1b0d29;
            }
        }
    }
</style>
